export const GET_LEAD_PROFILE_REQUEST = 'GET_LEAD_PROFILE_REQUEST';
export const GET_LEAD_PROFILE_REQUEST_SUCCESS = 'GET_LEAD_PROFILE_REQUEST_SUCCESS';
export const GET_LEAD_PROFILE_REQUEST_FAILURE = 'GET_LEAD_PROFILE_REQUEST_FAILURE';

export const CHANGE_REF_BIKE_LEAD_REQUEST = 'CHANGE_REF_BIKE_LEAD_REQUEST';
export const CHANGE_REF_BIKE_LEAD_REQUEST_SUCCESS = 'CHANGE_REF_BIKE_LEAD_REQUEST_SUCCESS';
export const CHANGE_REF_BIKE_LEAD_REQUEST_FAILURE = 'CHANGE_REF_BIKE_LEAD_REQUEST_FAILURE';

export const SET_REF_BIKE_LEAD_REDUCER = 'SET_REF_BIKE_LEAD_REDUCER';
export const SET_REF_LEAD_CUSTOMER_REDUCER = 'SET_REF_LEAD_CUSTOMER_REDUCER';
export const SET_MARKETING_REDUCER = 'SET_MARKETING_REDUCER';
export const SET_LEAD_VALUATIONS_REDUCER = 'SET_LEAD_VALUATIONS_REDUCER';
export const SET_MOT_HISTORY_REDUCER = 'SET_MOT_HISTORY_REDUCER';
export const SET_CAP_VALUATION_REDUCER = 'SET_CAP_VALUATION_REDUCER';
export const SET_LEAD_NOTES_REDUCER = 'SET_LEAD_NOTES_REDUCER';

export const GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS = 'GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS';
export const GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_FAILURE = 'GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_FAILURE';

export const GET_LEADS_PROFILE_WITH_NOTES_REQUEST = 'GET_LEADS_PROFILE_WITH_NOTES_REQUEST';
export const GET_LEADS_PROFILE_WITH_NOTES_REQUEST_SUCCESS = 'GET_LEADS_PROFILE_WITH_NOTES_REQUEST_SUCCESS';
export const GET_LEADS_PROFILE_WITH_NOTES_REQUEST_FAILURE = 'GET_LEADS_PROFILE_WITH_NOTES_REQUEST_FAILURE';

export const CHANGE_LEADS_CUSTOMER_REQUEST = 'CHANGE_LEADS_CUSTOMER_REQUEST';
export const CHANGE_LEADS_CUSTOMER_REQUEST_SUCCESS = 'CHANGE_LEADS_CUSTOMER_REQUEST_SUCCESS';
export const CHANGE_LEADS_CUSTOMER_REQUEST_FAILURE = 'CHANGE_LEADS_CUSTOMER_REQUEST_FAILURE';

export const UPDATE_BIKE_LEAD_UPGRADES_REQUEST = 'UPDATE_BIKE_LEAD_UPGRADES_REQUEST';
export const UPDATE_BIKE_LEAD_UPGRADES_SUCCESS = 'UPDATE_BIKE_LEAD_UPGRADES_SUCCESS';

export const CHANGE_LEAD_POT = 'CHANGE_LEAD_POT';

export const UPDATE_LEAD_CUSTOMER_DATE_REQUEST = 'UPDATE_LEAD_CUSTOMER_DATE_REQUEST';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/get_lead_profile.constants.js